// extracted by mini-css-extract-plugin
export var card = "PlanTypeCard-module__card___UnV_d";
export var active = "PlanTypeCard-module__active___HDUQ8";
export var staticCard = "PlanTypeCard-module__staticCard___m4koW";
export var contents = "PlanTypeCard-module__contents___R_MuW";
export var discount = "PlanTypeCard-module__discount___wHxFT";
export var label = "PlanTypeCard-module__label___OX7U5";
export var button = "PlanTypeCard-module__button___b9szY";